import { useState, useEffect, useRef } from 'react';
import { useLocalParticipant } from '@livekit/components-react';
import { Track } from 'livekit-client';
import './AvatarPickerScreen.css';

export default function AvatarPickerScreen({ avatars = [], selectedId, onSelect }) {
  const [hoveredId, setHoveredId] = useState(null);
  const { localParticipant } = useLocalParticipant();
  const userVideoRef = useRef(null);

  useEffect(() => {
    const el = userVideoRef.current;
    if (!el || !localParticipant) return;
    const attach = () => {
      const pub = localParticipant.getTrackPublication(Track.Source.Camera);
      if (pub?.track) pub.track.attach(el);
    };
    attach();
    localParticipant.on('trackPublished', attach);
    localParticipant.on('localTrackPublished', attach);
    return () => {
      localParticipant.off('trackPublished', attach);
      localParticipant.off('localTrackPublished', attach);
      const pub = localParticipant.getTrackPublication(Track.Source.Camera);
      if (pub?.track) pub.track.detach(el);
    };
  }, [localParticipant]);

  return (
    <div className="aps-root">
      <h2 className="aps-title">Pick an AI avatar to interact with</h2>

      {avatars.length === 0 ? (
        <div className="aps-loading">
          <div className="aps-spinner" />
          <span>Loading avatars…</span>
        </div>
      ) : (
        <div className="aps-row">
          {avatars.map((av) => {
            const isHov = hoveredId === av.id;
            const isDim = hoveredId !== null && !isHov;
            const isSelected = selectedId === av.id;
            return (
              <button
                key={av.id}
                className={`aps-card ${isHov ? 'hovered' : ''} ${isDim ? 'dimmed' : ''} ${isSelected ? 'selected' : ''}`}
                onMouseEnter={() => setHoveredId(av.id)}
                onMouseLeave={() => setHoveredId(null)}
                onClick={() => onSelect(av)}
              >
                <div className="aps-img-wrap">
                  {av.thumbnailUrl ? (
                    <img src={av.thumbnailUrl} alt={av.name} className="aps-img" />
                  ) : (
                    <div className="aps-placeholder">
                      <svg width="40" height="40" viewBox="0 0 80 80" fill="none">
                        <circle cx="40" cy="30" r="16" stroke="#7b61ff" strokeWidth="2.5" fill="none" />
                        <path d="M12 70c0-15.46 12.54-28 28-28s28 12.54 28 28" stroke="#7b61ff" strokeWidth="2.5" fill="none" />
                      </svg>
                    </div>
                  )}
                  {isSelected && <div className="aps-selected-ring" />}
                </div>
                <div className="aps-name-badge">
                  <div className="aps-audio-bars">
                    <span className="aps-bar" />
                    <span className="aps-bar" />
                    <span className="aps-bar" />
                    <span className="aps-bar" />
                  </div>
                  <span className="aps-name">{av.name}</span>
                </div>
              </button>
            );
          })}
        </div>
      )}

      {/* User PiP — bottom right */}
      <div className="aps-pip">
        <div className="aps-pip-header">
          <div className="aps-pip-dots"><span /><span /><span /></div>
          <span className="aps-pip-label">You</span>
          <span className="aps-pip-chevron">∧</span>
        </div>
        <video ref={userVideoRef} autoPlay playsInline muted className="aps-pip-video" />
      </div>
    </div>
  );
}
